import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import Dialog from '@/components/dialogs/Dialog';
import { hideCatalogueConfirmation, updateDatasetSettings } from '../actions';

const CatalogueChangeConfirmation = ({
  category,
  code,
  open,
  hide,
  template,
  theme,
  title,
  updateSettings,
}) => {
  const intl = useIntl();
  return (
    <Dialog
      className="aridhia-catalogue-change-confirmation"
      icon="book"
      message="settings.confirm.catalogue.change"
      messageIcon="warning circle"
      minimumDataEntryMet
      onClose={hide}
      onSave={() => updateSettings(category, code, { catalogue_definition_code: template.code }, title)}
      open={open}
      saveMessageId="actions.apply"
      theme={theme}
      title={intl.formatMessage({ id: 'settings.catalogue.change.title' })}
      values={{ name: `'${template.name}'` }}
      warning
    />
  );
};

const mapStateToProps = ({
  datasetSettings: { confirmCatalogue },
}) => ({
  ...confirmCatalogue,
});

const mapDispatchToProps = {
  hide: hideCatalogueConfirmation,
  updateSettings: updateDatasetSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogueChangeConfirmation);
